import React from "react";

export default function EmployeeSalaryAssignmentTable({
  assignments,
  onEdit,
  onDelete,
}) {
  return (
    <div className="finance-table-card">
      <table className="finance-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Employee ID</th>
            <th>Employee Name</th>
            <th>Department</th>
            <th>Designation</th>
            <th>Salary Structure</th>
            <th>Effective Date</th>
            <th>Status</th>
            <th style={{ textAlign: "center" }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {assignments.length === 0 ? (
            <tr>
              <td
                colSpan="9"
                style={{
                  textAlign: "center",
                  padding: "30px",
                  color: "#888",
                }}
              >
                No salary assignments found.
              </td>
            </tr>
          ) : (
            assignments.map((assignment, index) => (
              <tr key={assignment.id}>
                <td>{index + 1}</td>

                <td>{assignment.employeeId}</td>

                <td>{assignment.employeeName}</td>

                <td>{assignment.department}</td>

                <td>{assignment.designation}</td>

                <td>
                  <span className="component-count-badge">
                    {assignment.salaryStructure}
                  </span>
                </td>

                <td>{assignment.effectiveDate}</td>

                <td>
                  <span
                    className={
                      assignment.status === "Active"
                        ? "status-active"
                        : "status-inactive"
                    }
                  >
                    {assignment.status}
                  </span>
                </td>

                <td className="finance-action-cell">
                  <button
                    className="edit-btn"
                    onClick={() => onEdit(assignment)}
                  >
                    Edit
                  </button>

                  <button
                    className="delete-btn"
                    onClick={() => onDelete(assignment.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}